import React from "react";
import AcquiringOperationsGenericSkeleton from "./AcquiringOperationsGenericSkeleton";

function AcquiringOperationsDetailSkeleton() {
  return (
    <>
      <AcquiringOperationsGenericSkeleton />
    </>
  );
}

export default AcquiringOperationsDetailSkeleton;
